t = require('views/internal/teacup-with-helpers')('header_warning_account_transfer_required')

module.exports = t.renderable ({ targetDate, enterpriseDisplayName }) ->
  t.a '.quiet.sso-notice-dismiss.js-dismiss-account-transfer', { href: "#", style: 'float: right' }, ->
    t.icon 'close'
  t.div '.sso-notice', ->
    t.p ->
      t.format 'will-convert-to-enterprise-member', { enterpriseDisplayName, targetDate }
    t.a '.sso-notice-learn-more', { href: 'https://help.trello.com/article/1122-converting-to-sso-login', target: 'blank' }, ->
      t.format 'learn-more'


// WEBPACK FOOTER //
// ./app/scripts/views/templates/header_warning_account_transfer_required.coffee